module.exports = __webpack_public_path__ + "1a604331bdbe71a860e6da96cf4c4693.svg";